import {
  ActivityIndicator,
  Image,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { getLoginData } from "../../../utility/AppStoreData";
import { Picker } from "@react-native-picker/picker";
import { AppImages } from "../../../utility/AppImages";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import * as ImagePicker from "expo-image-picker";
import { toast } from "react-toastify";
import { AppScreens } from "../../Utility/AppScreens";

import HelpChatComponent from "../WebScreens/HelpChatComponent";
import { createTicketAPI } from "../../../utility/services/createHelpTicket";
import { updateHelpTicketAPI } from "../../../utility/services/updateHelpTicket";
import useAdminStatus from "../../../utility/hooks/useAdminStatus";
import { ScreenBGGradientView } from "../../../common/CommonView";

export enum enumAddEditPublicPrivateScreen {
  Add = "Add",
  Edit = "Edit",
}

export default function CreateTicketEventScreen({ route, navigation }) {
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [ticketName, setTicketName] = useState("");
  const [selectGame, setSelectGame] = useState("Fortnite");
  const [image, setImage] = useState(null);
  const [description, setDescription] = useState("");
  const [eventID, setEventID] = useState("");
  const [device, setDevice] = useState("PC");
  const [status, setStatus] = useState("Pending");
  const [ticketId, setTicketId] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const isAdmin = useAdminStatus();

  useEffect(() => {
    getLoginUserData();
    if (route.params.checkScreen === enumAddEditPublicPrivateScreen.Edit) {
      editEvent(route.params.ticketData);
    }
  }, []);

  const pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 1,
    });

    if (!result.canceled) {
      setImage(result.assets[0].uri);
    }
  };

  function editEvent(ticketData) {
    setTicketName(ticketData.ticketName);
    setSelectGame(ticketData.gameTitle);
    setEventID(ticketData.eventID);
    setDevice(ticketData.device);
    setStatus(ticketData.status);
    setDescription(ticketData.description);
    setImage(ticketData.image);
    setTicketId(ticketData.ticketId);
  }

  async function getLoginUserData() {
    const data = await getLoginData();
    if (data != null) {
      setUserData(data);
    }
  }

  const checkValidation = async () => {
    if (ticketName === "") {
      toast.error("Please enter event name");
    } else if (eventID === "") {
      toast.error("Please enter event ID");
    } else if (device === "") {
      toast.error("Please select device");
    } else if (description === "") {
      toast.error("Please enter description");
    } else {
      const newTicketData = {
        ticketName,
        gameTitle: selectGame,
        eventID,
        device,
        description,
        image,
        ticketId,
        status,
        type: route.params.eventType,
      };

      try {
        setLoading(true);
        if (
          (route.params.checkScreen || "Add") ===
          enumAddEditPublicPrivateScreen.Add
        ) {
          await createTicketAPI(newTicketData);
          toast.success("Ticket created successfully");
        } else {
          await updateHelpTicketAPI(route.params.ticketData.TicketID);
          toast.success("Ticket status updated successfully");
        }

        navigateToScreen(navigation, AppScreens.ContactUsCenter);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <View style={[styles.container]}>
      <ScreenBGGradientView />
      <View style={[styles.mainView]}>
        {deviceSize !== DEVICE_SIZES.XS ? (
          <View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: 40,
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_32,
                  {
                    color: AppColors.white,
                    alignSelf: "center",
                  },
                ]}
              >
                {(route.params.checkScreen || "Add") ===
                enumAddEditPublicPrivateScreen.Add
                  ? "Create Ticket"
                  : "Edit Ticket"}
              </Text>

              <View
                style={{
                  justifyContent: "center",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_14,
                    {
                      color: AppColors.white,
                      alignItems: "center",
                      justifyContent: "center",
                      alignSelf: "center",
                    },
                  ]}
                >
                  {userData != null ? userData.username : ""}
                </Text>

                <View
                  style={{
                    height: 50,
                    aspectRatio: 1,
                    backgroundColor: AppColors.appViolentColor_6D08C3,
                    borderRadius: 100,
                  }}
                />
              </View>
            </View>
            <View style={styles.divider} />
          </View>
        ) : null}
        <ScrollView showsVerticalScrollIndicator={false}>
          <View style={{ flexDirection: "column", flex: 1 }}>
            <View style={[styles.formMainView]}>
              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_14, styles.headerTitle]}
              >
                Ticket Event Details
              </Text>
              <View style={styles.mainInputWrapper}>
                <View style={styles.leftWrapper}>
                  <View style={{ width: "100%" }}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        styles.lableStyle,
                      ]}
                    >
                      Ticket name
                    </Text>

                    <View style={[styles.inputWrapper]}>
                      <TextInput
                        placeholder={"Enter Ticket Name"}
                        multiline={false}
                        placeholderTextColor={AppColors.gray_C4C4C4}
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_14,
                          styles.textInputStyle,
                        ]}
                        onChangeText={setTicketName}
                        keyboardType="default"
                        secureTextEntry={false}
                        value={ticketName}
                        editable={
                          route.params.checkScreen !==
                          enumAddEditPublicPrivateScreen.Edit
                        }
                      />
                    </View>
                  </View>
                </View>
                <View style={styles.rightWrapper}>
                  <View style={{ width: "47%" }}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        styles.lableStyle,
                      ]}
                    >
                      Status
                    </Text>
                    <View style={[styles.inputWrapper]}>
                      <Picker
                        selectedValue={status}
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_14,
                          styles.dropDownStyle,
                        ]}
                        onValueChange={(itemValue, itemIndex) =>
                          setStatus(itemValue)
                        }
                        enabled={isAdmin}
                      >
                        <Picker.Item
                          style={[AppFontStyle.REGULAR_ANYBODY_18]}
                          label="Pending"
                          value="Pending"
                        />
                        <Picker.Item
                          style={[AppFontStyle.REGULAR_ANYBODY_18]}
                          label="Completed"
                          value="Completed"
                        />
                      </Picker>
                    </View>
                  </View>
                </View>
              </View>
              <View style={styles.divider} />

              <View style={styles.mainInputWrapper}>
                <View style={styles.leftWrapper}>
                  <Text
                    style={[AppFontStyle.REGULAR_ANYBODY_12, styles.lableStyle]}
                  >
                    Select the game
                  </Text>
                  <View style={[styles.inputWrapper]}>
                    <Picker
                      selectedValue={selectGame}
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.dropDownStyle,
                      ]}
                      onValueChange={(itemValue, itemIndex) =>
                        setSelectGame(itemValue)
                      }
                      enabled={
                        route.params.checkScreen !==
                        enumAddEditPublicPrivateScreen.Edit
                      }
                    >
                      <Picker.Item
                        style={[AppFontStyle.REGULAR_ANYBODY_18]}
                        label="Fortnite"
                        value="Fortnite"
                      />
                      <Picker.Item
                        style={[AppFontStyle.REGULAR_ANYBODY_18]}
                        label="Valorant"
                        value="Valorant"
                      />
                    </Picker>
                  </View>
                </View>

                <View style={styles.rightWrapper}>
                  <Text
                    style={[AppFontStyle.REGULAR_ANYBODY_12, styles.lableStyle]}
                  >
                    Event ID
                  </Text>
                  <View style={[styles.inputWrapper]}>
                    <TextInput
                      placeholder={""}
                      multiline={false}
                      placeholderTextColor={AppColors.gray_C4C4C4}
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.textInputStyle,
                      ]}
                      onChange={(e) => setEventID(e.nativeEvent.text)}
                      secureTextEntry={false}
                      value={eventID}
                      editable={
                        route.params.checkScreen !==
                        enumAddEditPublicPrivateScreen.Edit
                      }
                    />
                  </View>
                </View>

                <View style={styles.rightWrapper}>
                  <Text
                    style={[AppFontStyle.REGULAR_ANYBODY_12, styles.lableStyle]}
                  >
                    Device
                  </Text>
                  <View style={[styles.inputWrapper]}>
                    <Picker
                      selectedValue={device}
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.dropDownStyle,
                      ]}
                      onValueChange={(itemValue, itemIndex) =>
                        setDevice(itemValue)
                      }
                      enabled={
                        route.params.checkScreen !==
                        enumAddEditPublicPrivateScreen.Edit
                      }
                    >
                      <Picker.Item
                        style={[AppFontStyle.REGULAR_ANYBODY_18]}
                        label="PC"
                        value="PC"
                      />
                      <Picker.Item
                        style={[AppFontStyle.REGULAR_ANYBODY_18]}
                        label="Play-station"
                        value="Play-station"
                      />
                    </Picker>
                  </View>
                </View>
              </View>

              <View style={{ gap: 20, flexDirection: "column" }}>
                <View style={styles.leftWrapper}>
                  <TouchableOpacity
                    onPress={pickImage}
                    disabled={
                      route.params.checkScreen ===
                      enumAddEditPublicPrivateScreen.Edit
                    }
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        {
                          color: AppColors.gray_C3C3C3,
                          padding: 10,
                        },
                      ]}
                    >
                      Thumbnail
                    </Text>
                    {image && (
                      <View
                        style={{
                          width: "100%",
                          height: 200,
                        }}
                      >
                        <Image
                          source={{ uri: image }}
                          style={{
                            height: "100%",
                            width: 200,
                            alignSelf: "center",
                            resizeMode: "contain",
                          }}
                        />
                      </View>
                    )}
                    {!image && (
                      <View
                        style={{
                          justifyContent: "center",
                          alignItems: "center",
                          paddingTop: 50,
                          paddingBottom: 80,
                        }}
                      >
                        <Image
                          source={AppImages.thumbnailIcon}
                          style={{
                            height: 20,
                            width: 20,
                            alignSelf: "center",
                            resizeMode: "contain",
                          }}
                        />
                      </View>
                    )}
                  </TouchableOpacity>
                </View>

                <View style={[styles.rightWrapper, { marginTop: 20 }]}>
                  <View style={[styles.inputWrapper]}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.headerTitle,
                      ]}
                    >
                      Description
                    </Text>
                    <TextInput
                      placeholder={""}
                      multiline={true}
                      placeholderTextColor={AppColors.gray_C4C4C4}
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.textInputStyle,
                        {
                          height: "100%",
                          marginBottom: 10,
                          verticalAlign: "top",
                        },
                      ]}
                      onChangeText={setDescription}
                      keyboardType="default"
                      secureTextEntry={false}
                      value={description}
                      editable={
                        route.params.checkScreen !==
                        enumAddEditPublicPrivateScreen.Edit
                      }
                    />
                  </View>
                </View>
              </View>
              <View style={styles.divider} />

              <View
                style={{
                  justifyContent: "flex-end",
                  flexDirection: "row",
                  marginTop: 20,
                  gap: 10,
                }}
              >
                <TouchableOpacity
                  style={{
                    borderRadius: 10,
                    marginBottom: 15,
                    justifyContent: "center",
                    alignItems: "center",
                    borderWidth: 2,
                    borderColor: AppColors.appViolentColor_6D08C3,
                  }}
                  onPress={() => {
                    navigation.dispatch(StackActions.pop());
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_12,
                      {
                        paddingVertical: 12,
                        paddingHorizontal: 40,
                        color: AppColors.white,
                      },
                    ]}
                  >
                    Back
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={{
                    backgroundColor: AppColors.appViolentColor_6D08C3,
                    borderRadius: 10,
                    marginBottom: 15,
                    minWidth: 111.39,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onPress={checkValidation}
                  disabled={loading}
                >
                  {loading ? (
                    <ActivityIndicator size="small" color={AppColors.white} />
                  ) : (
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_12,
                        {
                          paddingVertical: 8,
                          paddingHorizontal: 40,
                          color: AppColors.white,
                        },
                      ]}
                    >
                      Save
                    </Text>
                  )}
                </TouchableOpacity>
              </View>
            </View>

            {route.params.checkScreen ===
              enumAddEditPublicPrivateScreen.Edit && (
              <HelpChatComponent
                deviceSize={deviceSize}
                title="Ticket Event chat"
                chatID="4cc83012-5b5d-45ee-996b-75c96e9e1ae2"
                onChatTap={() => {
                  // Define what happens when Chat button is tapped
                }}
              />
            )}
          </View>
        </ScrollView>
      </View>
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
    },
    eventView: {
      marginTop: 5,
      marginBottom: 5,
      alignSelf: "flex-end",
    },
    chatBox: {
      marginTop: 30,
      position: "absolute",
      right: 0,
      bottom: -150,
    },
    formMainView: {
      flex: 2.5,
      width: "60%",
      marginTop: 10,
    },
    mainView: {
      flex: 1,
      paddingHorizontal: 40,
      marginHorizontal: 30,
    },
    divider: {
      height: 2,
      marginTop: 16,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: "100%",
    },
    headerTitle: {
      color: AppColors.white,
      paddingTop: 16,
    },
    chatOuterView: {
      margin: 5,
      backgroundColor: AppColors.grayColor_282828,
      borderRadius: 12,
      paddingHorizontal: 10,
      marginVertical: 10,
    },
    btnChat: {
      paddingVertical: 0,
      paddingHorizontal: 15,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      shadowOpacity: 0,
      height: 40,
      marginTop: 10,
      borderRadius: 7,
    },
    lableStyle: {
      color: AppColors.white,
      paddingTop: 14,
    },
    inputWrapper: {
      flex: 1,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      paddingHorizontal: 12,
      borderRadius: 10,
    },
    textInputStyle: {
      paddingVertical: 18,
      paddingHorizontal: 10,
      color: AppColors.white,
      outlineStyle: "none",
    },
    leftWrapper: {
      width: "40%",
      flexDirection: "column",
      gap: 12,
    },
    rightWrapper: {
      flex: 1,
      flexDirection: "column",
      gap: 12,
    },
    dropDownStyle: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      borderColor: AppColors.appGrayColor_1C1C1C,
      paddingVertical: 18,
      color: AppColors.white,
      outlineStyle: "none",
    },
    mainInputWrapper: {
      flexDirection: "row",
      gap: 20,
    },
    rightDurationWrapper: {
      width: "20%",
      flexDirection: "column",
      gap: 12,
    },
    gameWrapper: {
      width: "40%",
      flexDirection: "column",
      gap: 12,
    },
    width80: {
      width: "80%",
    },
    challegeMode: {
      flexDirection: "row",
      justifyContent: "space-evenly",
      gap: 30,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
      },
      chatBox: {
        marginTop: 30,
        position: "relative",
        right: 0,
        bottom: -0,
      },
      formMainView: {
        flex: 2.5,
        width: "100%",
        marginTop: 10,
      },
      mainView: {
        flex: 1,
        paddingHorizontal: 40,
        marginHorizontal: 30,
      },
      divider: {
        height: 2,
        marginTop: 16,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },
      lableStyle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 14,
      },
      inputWrapper: {
        flex: 1,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        width: "40%",
        flexDirection: "column",
        gap: 12,
      },
      rightWrapper: {
        // width: "20%",
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
      dropDownStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        borderColor: AppColors.appGrayColor_1C1C1C,
        paddingVertical: 18,
        color: AppColors.white,
      },
      mainInputWrapper: {
        flexDirection: "row",
        gap: 20,
      },
      rightDurationWrapper: {
        width: "20%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        width: "40%",
        flexDirection: "column",
        gap: 12,
      },
      width80: {
        width: "80%",
      },
      challegeMode: {
        flexDirection: "row",
        justifyContent: "space-evenly",
        gap: 30,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
      },
      chatBox: {
        marginTop: 30,
        position: "relative",
        right: 0,
        bottom: -0,
      },
      formMainView: {
        flex: 2.5,
        width: "100%",
        marginTop: 10,
      },
      mainView: {
        flex: 1,
        paddingHorizontal: 25,
        marginHorizontal: 16,
      },
      divider: {
        height: 2,
        marginTop: 16,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },
      lableStyle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 14,
      },
      inputWrapper: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        width: "50%",
        flexDirection: "column",
        gap: 12,
      },
      rightWrapper: {
        // width: "20%",
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
      dropDownStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        borderColor: AppColors.appGrayColor_1C1C1C,
        paddingVertical: 18,
        color: AppColors.white,
      },
      mainInputWrapper: {
        flexDirection: "row",
        gap: 20,
      },
      rightDurationWrapper: {
        width: "20%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
      width80: {
        width: "80%",
      },
      challegeMode: {
        flexDirection: "row",
        justifyContent: "space-evenly",
        gap: 30,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
      },
      chatBox: {
        marginTop: 30,
        position: "relative",
        right: 0,
        bottom: -0,
      },
      formMainView: {
        flex: 2.5,
        width: "100%",
        marginTop: 10,
      },
      mainView: {
        flex: 1,
        paddingHorizontal: 16,
        marginHorizontal: 16,
      },
      divider: {
        height: 2,
        marginTop: 16,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },
      lableStyle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 14,
      },
      inputWrapper: {
        flex: 1,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        width: "40%",
        flexDirection: "column",
        gap: 12,
      },
      rightWrapper: {
        width: "20%",
        flexDirection: "column",
        // gap: 12,
        flex: 1,
      },
      dropDownStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        borderColor: AppColors.appGrayColor_1C1C1C,
        paddingVertical: 18,
        color: AppColors.white,
      },
      mainInputWrapper: {
        flexDirection: "row",
        gap: 20,
      },
      rightDurationWrapper: {
        width: "20%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        width: "40%",
        flexDirection: "column",
        gap: 12,
      },
      width80: {
        width: "80%",
      },
      challegeMode: {
        flexDirection: "row",
        justifyContent: "space-evenly",
        gap: 30,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
      },
      chatBox: {
        marginTop: 30,
        position: "relative",
        right: 0,
        bottom: -0,
      },
      formMainView: {
        flex: 2.5,
        width: "100%",
        marginTop: 10,
      },
      mainView: {
        flex: 1,
        paddingHorizontal: 0,
      },
      divider: {
        height: 2,
        marginTop: 16,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },
      lableStyle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 14,
      },
      inputWrapper: {
        flex: 1,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        width: "100%",
        flexDirection: "column",
        gap: 12,
      },
      rightWrapper: {
        // width: "100%",
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
      dropDownStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        borderColor: AppColors.appGrayColor_1C1C1C,
        paddingVertical: 18,
        color: AppColors.white,
      },
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      rightDurationWrapper: {
        width: "100%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        width: "100%",
        flexDirection: "column",
        gap: 12,
      },
      width80: {
        width: "100%",
      },
      challegeMode: {
        flexDirection: "column",
        justifyContent: "space-evenly",
        gap: 30,
      },
    },
  }
);
